export default "__VITE_ASSET__C_bOZO4f__"